// extracted by mini-css-extract-plugin
export var item = "Marquee-module--item--bb14f";
export var items = "Marquee-module--items--4afad";
export var marquee = "Marquee-module--marquee--63467";